"use client";

export const GtmEvents = {
	CLICK_INSTALL: "click_install",
	CLICK_ALSO_FEATURED: "click_also_featured",
	QUIZ_INTERACTION: "quiz_interaction",
};

export const GtmProperties = {
	GfeTopTen: {
		PAGE_NAME: "page_name",
		POSITION: "position",
		ELEMENT_TEXT: "element_text",
		DEVICE: "device",
	},
	GfeQuizStep: {
		STRIPE_CHECKOUT_SUCCESS: "stripe_checkout_success",
	},
	GfeQuizCheckout: {
		PURCHASE_VALUE: "purchase_value",
		TRANSACTION_ID: "transaction_id",
		PROMOTION_CODE: "promotion_code",
	},
};
